import { ProductRedemptionPinCharacteristicsInfoDto } from './../../product/redemption/pin-characteristics-info.dto';

export class ProductLineRedemptionDto {
  id: string;
  redemptionLocation: string[];
  redemptionMethod: string[];
  pinCharacteristicsInfo: ProductRedemptionPinCharacteristicsInfoDto;

  constructor(d?: ProductLineRedemptionDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
